import { render } from "./workbench.vue?vue&type=template&id=49bf0532"
import script from "./workbench.vue?vue&type=script&lang=js"
export * from "./workbench.vue?vue&type=script&lang=js"

import "./workbench.vue?vue&type=style&index=0&id=49bf0532&lang=scss"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__